var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import "./RibbonMenuStyle.scss";
var RibbonMenuComponent = /** @class */ (function () {
    // private options: IStackPanelOptions;
    function RibbonMenuComponent(groups) {
        this.groups = groups;
        // this.options = {...{orientation: "horizontal", verticalAlign: "stretch"}, ...options};
    }
    RibbonMenuComponent.prototype.isEqual = function (node) {
        return this.__proto__ === node.__proto__;
    };
    RibbonMenuComponent.prototype.render = function () {
        return {
            tag: "div", attr: { class: "ribbon-menu-comp" },
            children: this.groups.map(function (g) {
                var _a;
                return {
                    tag: "div", attr: { class: "ribbon-group" },
                    children: __spreadArray([{ tag: "div", attr: { class: "ribbon-legend" }, content: (_a = g.title) !== null && _a !== void 0 ? _a : "" }], g.children, true)
                };
            })
        };
    };
    return RibbonMenuComponent;
}());
export { RibbonMenuComponent };
